export default __webpack_public_path__ + "static/media/instagram-logo.0a7eae2e.svg";